import React from "react";
import Flagship from "../../core/flagship";
import { Loader, Grid, Icon } from "semantic-ui-react";
import moment from "moment-business-days";
import { connect } from "react-redux";
import { DateInput } from "semantic-ui-calendar-react";
import TimeTrackingEntry from "../misc/TimeTrackingEntry";
import "../../styles/timeTracking.scss";
import { Link } from "react-router";

class TimeTracking extends React.Component {
  constructor(props) {
    super(props);

    let selectedDate;

    if (props.params.hasOwnProperty("date")) {
      selectedDate = moment(props.params.date, "MM-DD-YYYY").format("MM/DD/YY");
    } else {
      selectedDate = moment(new Date()).format("MM/DD/YY");
    }

    this.state = {
      selectedDate: selectedDate,
      selectedMonth: moment(selectedDate, "MM/DD/YY").format("YYYY-MM")
    };
    this.selectDate = this.selectDate.bind(this);
    this.getHoursForMonth = this.getHoursForMonth.bind(this);
    this.updateSelectedMonth = this.updateSelectedMonth.bind(this);
    this.addCalendarNavEventListeners = this.addCalendarNavEventListeners.bind(
      this
    );
  }

  addRealMonth(d) {
    let fm = moment(d).add(1, "M");
    let fmEnd = moment(fm).endOf("month");
    return d.date() !== fm.date() && fm.isSame(fmEnd.format("YYYY-MM-DD"))
      ? fm.add(1, "d")
      : fm;
  }

  subtractRealMonth(d) {
    let fm = moment(d).subtract(1, "M");
    let fmEnd = moment(fm).endOf("month");
    return d.date() !== fm.date() && fm.isSame(fmEnd.format("YYYY-MM-DD"))
      ? fm.subtract(1, "d")
      : fm;
  }

  addCalendarNavEventListeners() {
    let self = this;

    if (document.querySelector(".time-tracking-calendar i.right") !== null) {
      document
        .querySelector(".time-tracking-calendar i.right")
        .addEventListener("click", function() {
          self.setState(
            {
              selectedMonth: self
                .addRealMonth(moment(self.state.selectedMonth, "YYYY-MM"))
                .format("YYYY-MM")
            },
            self.getHoursForMonth
          );
        });
    }

    if (document.querySelector(".time-tracking-calendar i.left") !== null) {
      document
        .querySelector(".time-tracking-calendar i.left")
        .addEventListener("click", function() {
          self.setState(
            {
              selectedMonth: self
                .subtractRealMonth(moment(self.state.selectedMonth, "YYYY-MM"))
                .format("YYYY-MM")
            },
            self.getHoursForMonth
          );
        });
    }
  }

  componentDidMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
    document.title = "Flagship / Time Tracking";

    this.addCalendarNavEventListeners();

    if (typeof this.props !== "undefined" && this.props.userId !== 0) {
      this.getHoursForMonth();
    }
  }

  updateSelectedMonth() {
    let self = this;
    self.setState(
      {
        selectedMonth: this.addRealMonth(
          moment(self.state.selectedMonth, "YYYY-MM")
        ).format("YYYY-MM")
      },
      self.getHoursForMonth
    );
  }

  componentDidUpdate(prevProps) {
    let self = this;

    if (prevProps.userId === 0 && this.props.userId !== 0) {
      this.addCalendarNavEventListeners();
      self.getHoursForMonth();
    }
  }

  getHoursForMonth(props = this.props) {
    let listedHours = document.getElementsByClassName("cal-date-hours");
    while (listedHours.length > 0) {
      listedHours[0].parentNode.removeChild(listedHours[0]);
    }

    let indicators = document.getElementsByClassName("corner-indicator");
    while (indicators.length > 0) {
      indicators[0].parentNode.removeChild(indicators[0]);
    }

    let self = this;

    Flagship.get(
      "timesheets/user/" + props.userId + "/month/" + this.state.selectedMonth,
      {},
      function(response) {
        if (response.data.success === true) {
          self.setState(
            {
              hoursForMonth: response.data.results
            },
            function() {
              let days = document.querySelectorAll(
                ".time-tracking-calendar td"
              );

              days.forEach(function(day) {
                if (!day.classList.contains("disabled")) {
                  let date = day.innerText.padStart(2, "0");
                  if (self.state.hoursForMonth.hasOwnProperty(date)) {
                    day.innerHTML =
                      day.innerHTML +
                      '<div class="cal-date-hours">' +
                      Math.round(self.state.hoursForMonth[date] * 100) / 100 +
                      " hours</div>";
                    day.innerHTML =
                      day.innerHTML + '<div class="corner-indicator"></div>';
                  }
                }
              });
            }
          );
        } else {
          Flagship.error(
            "Failed to retrieve hours for month.",
            props.timerClient.client,
            props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to retrieve hours for month: " + err,
          props.timerClient.client,
          props.userId
        );
      }
    );
  }

  selectDate(e, data) {
    let self = this;
    this.setState(
      {
        selectedDate: data.value
      },
      function() {
        Flagship.redirect(
          "/time/date/" +
            moment(self.state.selectedDate, "MM/DD/YY").format("MM-DD-YYYY")
        );
      }
    );
  }

  render() {
    if (this.props.token !== null) {
      return (
        <Grid>
          <Grid.Column
            mobile={16}
            tablet={16}
            computer={6}
            largeScreen={7}
            widescreen={8}
          >
            <div className="fade-in time-tracking-calendar">
              <DateInput
                inline
                name="date"
                dateFormat="MM/DD/YY"
                value={this.state.selectedDate}
                onChange={this.selectDate}
              />
              <Link className="white-text" to={"/time/entries"}>
                <Icon name="list" />
                List View
              </Link>
              {this.props.userRole === "admin" ? (
                <Link className="white-text float-right" to={"/time/reports"}>
                  <Icon name="calculator" />
                  See Reports (All Users)...
                </Link>
              ) : null}
            </div>
          </Grid.Column>
          <Grid.Column
            mobile={16}
            tablet={16}
            computer={10}
            largeScreen={9}
            widescreen={8}
          >
            <TimeTrackingEntry
              fromTimer={this.props.route.fromTimer}
              fromPrevious={this.props.route.fromPrevious}
              addingTime={this.props.route.adding}
              selectedDate={this.state.selectedDate}
              addTime={this.addTime}
              onUpdate={this.getHoursForMonth}
            />
          </Grid.Column>
        </Grid>
      );
    } else {
      return (
        <div>
          <Loader className="flagship-loader" active={true} inline />
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId,
    timerRunning: state.time.timerRunning,
    timeRecorded: state.time.timeRecorded,
    timeRecordedFormatted: state.time.timeRecordedFormatted,
    timerClient: state.time.timerClient
  };
}

export default connect(mapStateToProps, null)(TimeTracking);



// WEBPACK FOOTER //
// ./src/components/views/TimeTracking.js